export const PARTY_MANAGE_APP_TYPE = 'party-manage-app-type';
export const PARTY_MANAGE_USERNAME = 'party-manage-username';
export const PARTY_MANAGE_DICT = 'party-manage-dict';
export const PARTY_MANAGE_TOKEN = 'party-manage-token';
export const PARTY_MANAGE_CODES = 'party-manage-codes';
export const PARTY_MANAGE_USERINFO = 'party-manage-userinfo';
